// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2La_I","head":"ProcedureTableInfo_head__1IaGq"};